<template>
    <div class="modal-overlay" @click.self="emitClose">
        <div class="modal">
            <div class="modal-header">
                <h1 class="modal-title">Zamów swoją konfigurację</h1>
                <button class="close-button" @click="emitClose">
                    <font-awesome-icon icon="xmark" size="xs" />
                </button>
            </div>
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="form-group">
                        <label for="firstName">Imię{{ !isCompany ? ' *' : '' }}</label>
                        <input id="firstName" v-model="firstName" placeholder="Imię" :required="!isCompany"
                            :disabled="isCompany" maxlength="255" />
                    </div>

                    <div class="form-group">
                        <label for="lastName">Nazwisko{{ !isCompany ? ' *' : '' }}</label>
                        <input id="lastName" v-model="lastName" placeholder="Nazwisko" :required="!isCompany"
                            :disabled="isCompany" maxlength="255" />
                    </div>

                    <div class="form-group">
                        <label for="email">Email *</label>
                        <input id="email" v-model="email" type="email" placeholder="Email" required maxlength="255" />
                    </div>

                    <div class="form-group">
                        <label for="phone">Numer telefonu *</label>
                        <input id="phone" type="tel" v-model="phone" placeholder="Numer telefonu" required
                            pattern="[0-9]{9,}" title="Numer telefonu musi zawierać co najmniej 9 cyfr" />
                    </div>

                    <div class="form-group">
                        <label for="address">Adres{{ !isCompany ? ' *' : '' }}</label>
                        <input id="address" v-model="address" placeholder="Adres" :required="!isCompany"
                            :disabled="isCompany" maxlength="500" />
                    </div>

                    <label class="company-checkbox">
                        <input type="checkbox" v-model="isCompany" />
                        Firma
                    </label>

                    <transition name="expand-fade">
                        <div v-if="isCompany" class="company-fields">
                            <div class="form-group">
                                <label for="companyName">Nazwa firmy *</label>
                                <input id="companyName" v-model="companyName" placeholder="Nazwa firmy" required
                                    maxlength="255" :disabled="!isCompany" />
                            </div>

                            <div class="form-group">
                                <label for="nip">NIP *</label>
                                <input id="nip" v-model="nip" placeholder="NIP" required maxlength="20"
                                    :disabled="!isCompany" />
                            </div>

                            <div class="form-group">
                                <label for="companyAddress">Adres firmy *</label>
                                <input id="companyAddress" v-model="companyAddress" placeholder="Adres firmy" required
                                    maxlength="255" :disabled="!isCompany" />
                            </div>

                            <div class="form-group">
                                <label for="country">Kraj *</label>
                                <select id="country" v-model="country" required :disabled="!isCompany"
                                    :class="{ 'placeholder-active': !country }">
                                    <option value="" disabled>Wybierz kraj</option>
                                    <option value="Albania">Albania</option>
                                    <option value="Andora">Andora</option>
                                    <option value="Austria">Austria</option>
                                    <option value="Belgia">Belgia</option>
                                    <option value="Białoruś">Białoruś</option>
                                    <option value="Bośnia i Hercegowina">Bośnia i Hercegowina</option>
                                    <option value="Bułgaria">Bułgaria</option>
                                    <option value="Chorwacja">Chorwacja</option>
                                    <option value="Czarnogóra">Czarnogóra</option>
                                    <option value="Czechy">Czechy</option>
                                    <option value="Dania">Dania</option>
                                    <option value="Estonia">Estonia</option>
                                    <option value="Finlandia">Finlandia</option>
                                    <option value="Francja">Francja</option>
                                    <option value="Grecja">Grecja</option>
                                    <option value="Hiszpania">Hiszpania</option>
                                    <option value="Holandia">Holandia</option>
                                    <option value="Irlandia">Irlandia</option>
                                    <option value="Islandia">Islandia</option>
                                    <option value="Kosowo">Kosowo</option>
                                    <option value="Liechtenstein">Liechtenstein</option>
                                    <option value="Litwa">Litwa</option>
                                    <option value="Luksemburg">Luksemburg</option>
                                    <option value="Łotwa">Łotwa</option>
                                    <option value="Macedonia Północna">Macedonia Północna</option>
                                    <option value="Malta">Malta</option>
                                    <option value="Mołdawia">Mołdawia</option>
                                    <option value="Monako">Monako</option>
                                    <option value="Niemcy">Niemcy</option>
                                    <option value="Norwegia">Norwegia</option>
                                    <option value="Polska">Polska</option>
                                    <option value="Portugalia">Portugalia</option>
                                    <option value="Rosja">Rosja</option>
                                    <option value="Rumunia">Rumunia</option>
                                    <option value="San Marino">San Marino</option>
                                    <option value="Serbia">Serbia</option>
                                    <option value="Słowacja">Słowacja</option>
                                    <option value="Słowenia">Słowenia</option>
                                    <option value="Szwajcaria">Szwajcaria</option>
                                    <option value="Szwecja">Szwecja</option>
                                    <option value="Ukraina">Ukraina</option>
                                    <option value="Watykan">Watykan</option>
                                    <option value="Węgry">Węgry</option>
                                    <option value="Wielka Brytania">Wielka Brytania</option>
                                    <option value="Włochy">Włochy</option>
                                </select>
                            </div>
                        </div>
                    </transition>

                    <div class="price-summary">
                        <div class="summary">
                            <h1 class="summary-title">Miejsce realizacji zamówienia:</h1>
                            <p>Sławacinek Nowy 26</p>
                        </div>
                        <div class="summary">
                            <h1 class="summary-title">Miejsce odbioru zamówienia:</h1>
                            <p>Sławacinek Nowy 26</p>
                        </div>
                    </div>

                    <div class="checkbox-consent">
                        <label>
                            <input type="checkbox" v-model="consentGiven" required />
                            <span>
                                Wyrażam zgodę na przetwarzanie moich danych osobowych w związku z wysłaną konfiguracją.
                                Podanie danych jest dobrowolne, ale konieczne do przetworzenia zapytania.
                                <a href="/privacy-policy" target="_blank">Więcej informacji</a> *
                            </span>
                        </label>
                    </div>

                    <div class="modal-actions">
                        <button type="submit" class="save-button" :disabled="orderLoading">
                            {{ orderLoading ? 'Przesyłanie...' : 'Prześlij konfigurację' }}
                        </button>
                        <button type="button" class="cancel-button" @click="emitClose">Anuluj</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div v-if="showSuccessModal" class="modal-overlay">
        <div class="modal submit-modal">
            <div class="modal-header">
                <h1 class="modal-title">Konfiguracja wysłana!</h1>
                <button class="close-button" @click="closeSuccessModal">
                    <font-awesome-icon icon="xmark" size="xs" />
                </button>
            </div>
            <div class="modal-content">
                <p>
                    Na Twoją skrzynkę e-mail została wysłana konfiguracja.<br />
                    Aby przekazać ją do nas, kliknij link w wiadomości potwierdzając wybór.
                </p>
            </div>
            <div class="modal-actions">
                <button type="button" class="save-button submit-button" @click="closeSuccessModal">
                    OK
                </button>
            </div>
        </div>
    </div>

    <div v-if="showLoadingModal" class="modal-overlay">
        <div class="modal submit-modal">
            <div class="modal-header">
                <h1 class="modal-title">Wysyłanie konfiguracji </h1>
            </div>
            <div class="modal-content">
                <p>
                    Trwa wysyłanie konfiguracji. Proszę czekać...
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { useTrailerStore } from '@/stores/trailerStore';
import { useOrderStore } from '@/stores/orderStore';
import { clearConfigStorage } from '@/services/configStorage';
import { showErrorToast, showWarningToast } from '@/utils/errorUtils';

export default {
    name: 'SaveConfigComponent',
    emits: ['close'],
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
            isCompany: false,
            country: '',
            companyName: '',
            nip: '',
            companyAddress: '',
            consentGiven: false,
            showSuccessModal: false,
            showLoadingModal: false
        };
    },
    computed: {
        orderLoading() {
            const orderStore = useOrderStore();
            return orderStore.loading;
        }
    },
    methods: {
        clearForm() {
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.phone = '';
            this.address = '';
            this.isCompany = false;
            this.country = '';
            this.companyName = '';
            this.nip = '';
            this.companyAddress = '';
            this.consentGiven = false;
        },
        emitClose() {
            this.clearForm();
            this.$emit('close');
        },
        closeSuccessModal() {
            this.showSuccessModal = false;
            this.$router.push('/order-confirmation');
        },
        async submit() {
            const trailerStore = useTrailerStore();
            const orderStore = useOrderStore();

            if (!trailerStore.selectedTrailer) {
                showWarningToast('Nie wybrano lawety')
                return
            }

            const payload = {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                phone: this.phone,
                customer_type: this.isCompany ? 'company' : 'individual',
                trailer_id: trailerStore.selectedTrailer.id,
                addon_ids: trailerStore.selectedTrailerAddons.map(addon => addon.id)
            };

            if (!this.isCompany && this.address?.trim()) payload.address = this.address;

            if (this.isCompany) {
                if (this.companyName?.trim()) payload.company_name = this.companyName;
                if (this.nip?.trim()) payload.nip = this.nip;
                if (this.companyAddress?.trim()) payload.company_address = this.companyAddress;
                if (this.country?.trim()) payload.country = this.country;
            }

            console.log('[ZAMÓWIENIE] Payload:', payload);

            try {
                this.showLoadingModal = true;
                const response = await orderStore.submitOrder(payload);
                console.log('[ZAMÓWIENIE] Odpowiedź:', response);
                this.clearForm();
                clearConfigStorage();
                this.showSuccessModal = true;
            } catch (err) {
                console.error('Nie udalo sie zapisac:', err)
                showErrorToast(err, 'Błąd przy zapisie zamówienia. Zobacz konsolę.')
            } finally {
                this.showLoadingModal = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
}

.modal {
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    background-color: $color-background;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 20px;
    background-color: $color-primary;
    color: $color-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
}

.close-button {
    background: none;
    border: none;
    color: $color-white;
    font-size: 2rem;
    cursor: pointer;
    padding: 0 10px;
    line-height: 1;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.modal-content {
    padding: 20px;
    overflow-y: auto;
    flex-grow: 1;

    form {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .form-group select.placeholder-active {
        color: #757575;
    }

    input::placeholder {
        color: #757575;
        opacity: 1;
    }

    input:-ms-input-placeholder {
        color: #757575;
    }

    input::-ms-input-placeholder {
        color: #757575;
    }

    .form-group select {
        font-size: 13px;
    }

    .form-group select:not(.placeholder-active) {
        color: #000;
    }

    .form-group select option {
        color: #000;
    }

    label {
        font-weight: 500;

        &::after {
            content: attr(data-required);
            color: red;
        }
    }

    input {
        padding: 10px;
        border: 2px solid $color-grey;
        border-radius: 8px;
        transition: all 0.5s ease;

        &:focus {
            border-color: $color-primary;
            outline: none;
        }
    }

    .company-checkbox {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 500;
        cursor: pointer;

        input[type='checkbox'] {
            transform: scale(1.3);
            accent-color: $color-primary;
        }
    }

    .company-fields {
        display: flex;
        flex-direction: column;
        gap: 10px;
        overflow: hidden;
    }

    select {
        padding: 10px;
        border: 2px solid $color-grey;
        border-radius: 8px;
        background-color: $color-white;
        transition: all 0.5s ease;
        font-size: 1rem;

        &:focus {
            border-color: $color-primary;
            outline: none;
        }

        &:disabled {
            background-color: #f4f4f4;
            cursor: not-allowed;
        }
    }

    .expand-fade-enter-active,
    .expand-fade-leave-active {
        transition: all 0.2s ease;
        overflow: hidden;
    }

    .expand-fade-enter-from,
    .expand-fade-leave-to {
        opacity: 0;
        max-height: 0;
    }

    .expand-fade-enter-to,
    .expand-fade-leave-from {
        opacity: 1;
        max-height: 500px;
    }

    .summary {
        padding-top: 10px;
        padding-bottom: 10px;

        &:first-child {
            border-top: 1px solid $color-grey;
            border-bottom: 1px solid $color-grey;
        }

        &:last-child {
            border-bottom: 1px solid $color-grey;
        }
    }

    .summary-title {
        color: $color-primary;
        font-size: 1.2rem;
        text-align: left;
    }

    .checkbox-consent {
        label {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            cursor: pointer;

            input[type='checkbox'] {
                transform: scale(1.3);
                accent-color: $color-primary;
                margin-top: 4px;
            }

            span {
                text-align: justify;
                display: block;
            }

            a {
                color: $color-primary;
                text-decoration: underline;
            }
        }
    }
}

.modal-actions {
    display: flex;
    gap: 15px;
    padding-top: 20px;

    button {
        flex: 1;
        padding: 12px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 500;
        transition: all 0.3s ease;
    }

    .save-button {
        background-color: $color-primary;
        color: $color-white;

        &:hover {
            background-color: $color-primary-dark;
        }

        &:disabled {
            display: none;
            opacity: 0.6;
            background-color: $color-primary-dark;
            cursor: not-allowed;
        }
    }

    .cancel-button {
        background-color: $color-grey;
        color: $color-text;

        &:hover {
            background-color: $color-grey-dark;
        }
    }
}

.submit-modal {
    width: 70%;
    max-width: 700px;
    animation: fadeInScale 0.3s ease forwards;
}

.submit-button {
    max-width: 200px;
    margin: 0 auto;
    margin-bottom: 20px;
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@media (max-width: 768px) {
    .modal-actions {
        flex-direction: column;
        gap: 10px;

        button {
            width: 100%;
        }
    }

    .modal-header {
        padding: 15px;
    }

    .modal-title {
        font-size: 1.3rem;
    }
}
</style>
